import React from 'react';
import "../styles/Footer.css";  

const Footer = () => (
  <footer className="footer">
    <span>&copy; 2024 BOOKREALM</span>
  </footer>
);

export default Footer;
